module.exports = __webpack_public_path__ + "quilt2-level2.8abf3db0.png";